import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '~/initializeStore';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';

/** One exam URL: wait for Firebase, then choose the application or the standalone result. */
export const ExamRoute: React.FC<{ application: React.ReactNode; result: React.ReactNode }> = ({ application, result }) => {
  const [signedIn, setSignedIn] = useState<boolean | null>(null);
  useEffect(() => onAuthStateChanged(auth, user => setSignedIn(Boolean(user && !user.isAnonymous))), []);
  if (signedIn === null) return <FullPageLoader />;
  return <>{signedIn ? application : result}</>;
};
